import { render, staticRenderFns } from "./GroupServiceList.vue?vue&type=template&id=baddecd4&scoped=true"
import script from "./GroupServiceList.vue?vue&type=script&lang=js"
export * from "./GroupServiceList.vue?vue&type=script&lang=js"
import style0 from "./GroupServiceList.vue?vue&type=style&index=0&id=baddecd4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baddecd4",
  null
  
)

export default component.exports